import { render, staticRenderFns } from "./DialogVinRegistration.vue?vue&type=template&id=deca192a"
import script from "./DialogVinRegistration.vue?vue&type=script&lang=js"
export * from "./DialogVinRegistration.vue?vue&type=script&lang=js"
import style0 from "./DialogVinRegistration.vue?vue&type=style&index=0&id=deca192a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports